import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import TrainerSuche from './TrainerSuche';

export default function TrainerLayout({ children, title = 'SwimDesk Trainer', backTo }) {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [sucheOffen, setSucheOffen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  // Die min-height steckt in der Klasse "trainer-shell" (styles/admin.css).
  // Dort lässt sich der dvh/vh-Rückfall mit zwei Deklarationen abbilden - in
  // einem style-Objekt ginge das nicht, dort überschreibt der zweite
  // gleichnamige Schlüssel den ersten.
  return (
    <div className="trainer-shell" style={{ display: 'flex', flexDirection: 'column', background: '#f0f4f8' }}>
      <div style={{
        background: '#1565c0', color: '#fff',
        padding: '0 1rem',
        display: 'flex', alignItems: 'center', gap: '0.5rem',
        height: 56, flexShrink: 0,
        position: 'sticky', top: 0, zIndex: 200,
        boxShadow: '0 2px 8px rgba(0,0,0,0.18)',
      }}>
        {sucheOffen ? (
          <TrainerSuche onSchliessen={() => setSucheOffen(false)} />
        ) : (<>
        {backTo ? (
          <button onClick={() => navigate(backTo)} style={{
            background: 'none', border: 'none', color: '#fff',
            fontSize: '1.4rem', cursor: 'pointer', padding: '0 0.25rem',
            display: 'flex', alignItems: 'center', flexShrink: 0,
          }}>←</button>
        ) : (
          <span style={{ fontSize: '1.3rem', flexShrink: 0 }}>🏊</span>
        )}

        <span style={{ fontWeight: 700, fontSize: '1rem', flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {title}
        </span>

        <button onClick={() => setSucheOffen(true)} aria-label="Kind suchen" title="Kind suchen" style={{
          background: 'rgba(255,255,255,0.18)', border: 'none', color: '#fff',
          borderRadius: 6, height: 32, padding: '0 0.6rem', fontSize: '0.85rem', cursor: 'pointer',
          flexShrink: 0, display: 'flex', alignItems: 'center', gap: 4,
        }}>🔍<span className="trainer-suche-text">Suche</span></button>

        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexShrink: 0 }}>
          <span style={{ fontSize: '0.78rem', opacity: 0.85, maxWidth: 90, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {user?.vorname}
          </span>
          <button onClick={handleLogout} style={{
            background: 'rgba(255,255,255,0.18)', border: 'none', color: '#fff',
            borderRadius: 6, padding: '0.3rem 0.6rem', fontSize: '0.78rem', cursor: 'pointer',
          }}>Abmelden</button>
        </div>
        </>)}
      </div>

      <div style={{ flex: 1, overflowY: 'auto', padding: '0.875rem', maxWidth: 640, width: '100%', margin: '0 auto', boxSizing: 'border-box' }}>
        {children}
      </div>
    </div>
  );
}
